import {Component, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {AuthService} from "../shared/security/auth.service";
import {AuthInfo} from "../shared/security/auth-info";
import {Router} from "@angular/router";
import {TableService} from "../shared/services/table/table.service";
import {RestaurantService} from "../shared/services/restaurant/restaurant.service";

@Component({
  selector: 'top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent implements OnInit, OnChanges{
  showMenu: boolean | false;

  authInfo:AuthInfo;

  constructor(
    private authService:AuthService,
    private router: Router,
    private tableService: TableService,
    private restaurantService: RestaurantService

  ) {

    this.authService.getShowMenu().subscribe(
      res => {
        this.showMenu = res;
        // console.log(this.showMenu);

      }
    )
  }

  ngOnInit() {
    this.authService.authInto$
      .subscribe(authInfo => this.authInfo = authInfo);
  }

  ngOnChanges(changes: SimpleChanges): void {
  /*
    this.authService.onUserChange().subscribe(
      (authInfo) => {
        // console.log(authInfo);
        this.authInfo = authInfo
      });
  */
  }

  logout(){
    this.authService.setShow(false);
    this.authService.logout();
    this.tableService.tableDisconnect();
    this.restaurantService.restaurantDisconnect();
    this.router.navigate(['/home']);

  }

  ngOnDestroy() {
    // this.logIt(`onDestroy`);
  }

  /*
  ngDoCheck() {
    this.logIt(`checkDetected`);
  }
  */

  ngOnChange(){
    // this.logIt('changeDetected');
  }

  private logIt(msg: string) {
    console.log(`${msg}`);
  }



}



// WEBPACK FOOTER //
// ./src/app/top-menu/top-menu.component.ts